// components/AlarmDialog.jsx
import React from "react";
import { useTranslation } from "react-i18next";

import {
  Box,
  Button,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material";

// import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

import { useAlarm } from "../providers/AlarmProvider";
import { makeFaultsMessage } from "data/data";
import { useEnumApi } from "contexts/EnumApiContext";

export default function AlarmDialog() {
  const { t } = useTranslation();
  const { getEnumValueByEnumNameAndCode } = useEnumApi();
  const {
    alarmQueue,
    currentAlarm,
    handleConfirm,
    handleOneceConfirm,
    isAckLoading,
    isSoundEnabled,
    setIsSoundEnabled,
    alarmReleasePermission
  } = useAlarm();

  if (!currentAlarm) {
    return null;
  }

  const open =
    alarmQueue.length > 0;

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      // maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          maxWidth: {
            xs: "95vw",
            sm: "560px",
          },
          maxHeight: "90vh", // 모바일 대응
          
          display: "flex",
          flexDirection: "column",
          
          borderRadius: 4,
          overflow: "hidden",
        },
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          background:
            "#C62828",
          color: "#fff",

          px: 3,
          py: 2,

          display: "flex",
          gap: 3,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            fontSize: 24,
            fontWeight: 700,
          }}
        >
          {t('message.common.title.alarm.count', { count: alarmQueue.length })}
        </Typography>

        <IconButton
          onClick={() =>
            setIsSoundEnabled(
              (prev) => !prev
            )
          }
          sx={{
            color: "#fff",
          }}
        >
          {isSoundEnabled ? (
            <VolumeUpIcon />
          ) : (
            <VolumeOffIcon />
          )}
        </IconButton>
      </Box>

      {/* BODY */}
      <Box
        sx={{
          display: "flex",
          gap: 3,
          px: 4,
          py: 5,
          alignItems: "center",
        }}
      >
        <img src={`${process.env.PUBLIC_URL}/img/siren_80.png`} />
        {/* <WarningAmberRoundedIcon
          sx={{
            fontSize: 72,
            color: "#D32F2F",
          }}
        /> */}

        <Box
          sx={{
            minWidth: 0,
            flex: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: 700,
              color: "#D32F2F",
              mb: 1,
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {currentAlarm?.equipment?.managementCompany?.info?.name}({currentAlarm?.equipment?.zone?.name})
          </Typography>

          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 700,
              color: "#807e7e",
              mb: 1,
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {currentAlarm?.equipment?.name}({currentAlarm?.equipment?.equipmentNo})
          </Typography>

          <Typography
            sx={{
              fontSize: 18,
              color: "#cdcdcd",
              maxHeight: 170,
              overflowY: "auto",

              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {currentAlarm && makeFaultsMessage(currentAlarm, getEnumValueByEnumNameAndCode, false, null)}
          </Typography>
        </Box>
      </Box>

      {/* FOOTER */}
      {alarmReleasePermission && (
      <Box
        sx={{
          px: 4,
          pb: 4,

          flexShrink: 0,
        }}
      >
        <Button
          variant="contained"
          color="error"
          fullWidth
          size="large"
          disabled={
            isAckLoading
          }
          onClick={
            // handleConfirm
            handleOneceConfirm
          }
          sx={{
            height: 56,
            fontSize: 20,
            fontWeight: 700,
            borderRadius: 3,
          }}
        >
          {t('message.common.btn.confirm')}
        </Button>
      </Box>
      )}
    </Dialog>
  );
}